/* eslint-disable react/prop-types */

import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import Footer from 'components/shared/footer';
import Header from 'components/shared/header';
import MobileMenu from 'components/shared/mobile-menu';

import MAIN_MENU_LINKS from '../constants';

const Layout = (props) => {
  const { children } = props;
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isContactShown, setShowContact] = useState(false);

  const handleHeaderBurgerClick = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    setShowContact(false);
    document.querySelector('body').classList.toggle('overflow-hidden');
  };

  const handleShowContact = () => setShowContact(!isContactShown);

  const menuLinks = [
    ...MAIN_MENU_LINKS,
    { text: 'Contact', to: '/', as: 'button', onClick: handleShowContact },
  ];

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.querySelector('body').classList.add('overflow-hidden');
      document.querySelector('.site-footer').classList.add('fixed');
      document.querySelector('.site-footer').classList.add('bottom-0');
      document.querySelector('.site-footer').classList.add('left-0');
      document.querySelector('.site-footer').classList.add('right-0');
      document.querySelector('.site-footer').classList.add('z-[9999]');
    } else {
      document.querySelector('body').classList.remove('overflow-hidden');
      document.querySelector('.site-footer').classList.remove('fixed');
      document.querySelector('.site-footer').classList.remove('bottom-0');
      document.querySelector('.site-footer').classList.remove('left-0');
      document.querySelector('.site-footer').classList.remove('right-0');
      document.querySelector('.site-footer').classList.remove('z-[9999]');
    }
  }, [isMobileMenuOpen]);

  return (
    <div
      className="flex min-h-screen flex-col pt-mobile-nav-height xl:pt-desktop-nav-height"
      {...props}
    >
      <MobileMenu
        isOpen={isMobileMenuOpen}
        setIsOpen={setIsMobileMenuOpen}
        links={menuLinks}
        onContactClick={handleShowContact}
      />
      <Header
        isMobileMenuOpen={isMobileMenuOpen}
        isContactShown={isContactShown}
        onBurgerClick={handleHeaderBurgerClick}
        onContactClick={handleShowContact}
      />
      <main className="flex-grow">{children}</main>
      <Footer isMobileMenuOpen={isMobileMenuOpen} />
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
